import {graphql, compose} from 'react-apollo';
import gql from 'graphql-tag';

import {
  DeleteMetaMutation,
  DeleteMetaMutationConfig,
  SaveMetaMutation,
  SaveMetaMutationConfig,
  ValidateMetaMutation,
  ValidateMetaMutationConfig
} from '../qql-shared/mutations';
import {Meta} from '../qql-shared/fragments';
import MetaDataForm from '../components/MetaDataForm';

const MetaQuery = gql`
  query meta($_id:String!) {
    meta(_id:$_id) {
      ...Meta
    }
  }
  ${Meta}
`;

const MetaQueryConfig = {
  options: ({match}) => ({variables: {_id: match.params.id}})
};

export default compose(
  graphql(ValidateMetaMutation, ValidateMetaMutationConfig),
  graphql(DeleteMetaMutation, DeleteMetaMutationConfig),
  graphql(SaveMetaMutation, SaveMetaMutationConfig),
  graphql(MetaQuery, MetaQueryConfig)
)(MetaDataForm);



// WEBPACK FOOTER //
// ./src/containers/MetaDataEdit.js